import { useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { toString } from '../../helpers/common'
import { updatePartnershipUrl } from '../../helpers/handlePartnershipSelection'
import { getAdAccountsData } from '../../helpers/handleAdAccountsSelection'

import { setThemeColor } from '../../modules/actions/app'
import { setSelectedPartnership } from '../../modules/actions/partnerships'
import { setSelectedAdAccounts } from '../../modules/actions/adAccounts'
import { getDefaultPartnershipId } from '../../modules/reducers/partnerships'
import {
  selectedPartnershipIdSelector,
  partnershipsSelector,
  partnershipsWasLoadedSelector
} from '../../modules/selectors/partnerships'
import { getPartnershipColors } from '../../helpers/other'
import { getAvailablePlatformList, selectValidPlatform } from '../../helpers/handlePlatformSelection'

export default function usePartnershipManage() {
  const dispatch = useDispatch()

  const selectedPartnershipId = useSelector(selectedPartnershipIdSelector)
  const partnerships = useSelector(partnershipsSelector)
  const partnershipsWasLoaded = useSelector(partnershipsWasLoadedSelector)

  const handlePartnershipChange = useCallback(
    ({ value: partnershipId, keepUserOnCurrentPage }) => {
      const newSelectedPartnership = partnerships.find(
        partnership => toString(partnership.id) === toString(partnershipId)
      )

      dispatch(setSelectedPartnership(newSelectedPartnership))
      dispatch(setSelectedAdAccounts(getAdAccountsData(newSelectedPartnership)))

      // select new color or clear previously existed
      dispatch(setThemeColor(getPartnershipColors(newSelectedPartnership)))

      updatePartnershipUrl(newSelectedPartnership, keepUserOnCurrentPage)
      // each partnership has it's own list of available platforms
      // so during partnership change correct platform should be selected
      const availablePlatformList = getAvailablePlatformList(newSelectedPartnership.providers)
      selectValidPlatform(availablePlatformList)
    },
    [dispatch, partnerships]
  )

  const autoSelectAccount = useCallback(
    // auto selection of partnership when there are no saved partnership
    () => {
      const newSelectedPartnershipId = getDefaultPartnershipId(partnerships)
      newSelectedPartnershipId && handlePartnershipChange({ value: newSelectedPartnershipId })
    },
    [partnerships, handlePartnershipChange]
  )

  useEffect(() => {
    // auto select partnership when selectedPartnership was cleared
    if (partnershipsWasLoaded && !selectedPartnershipId) {
      autoSelectAccount()
    }
  }, [selectedPartnershipId, autoSelectAccount, partnershipsWasLoaded])

  return {
    handlePartnershipChange
  }
}
